import { TilingSprite } from "pixi.js";

export default class Background {
  public sprite: TilingSprite;

  constructor(sprite: TilingSprite) {
    this.sprite = sprite;
  }

  reset() {
    this.sprite = null as any;
  }
}
